/**
 * Substital: Add subtitles to videos and movies
 *
 * Declares a single web-accessible-resource entry (`injection/*`, `detection/detectors/*`,
 * `css/*` and more) matched to every origin with no `use_dynamic_url` — so its injected
 * bundle, per-player detector scripts and stylesheets are all fetchable from any page at
 * a fixed URL.
 *
 * There are no bundled icons in the WAR set, so the primary signal is the vendor-named
 * `injection/bundle.js`; the per-player detector scripts corroborate it.
 *
 * Manifest verified against version 2.10.5.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kkkbiiikppgjdiebcabomlbidfodipjg';

export const substital: ExtensionDefinition = {
  id: ID,
  name: 'Substital: Add subtitles to videos and movies',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Exposes injection, detection and css directories to every origin with no dynamic ' +
    'URL. The injected bundle and per-player detector scripts are conclusive.',
  signals: [
    {
      id: 'war-injection-bundle-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch injection/bundle.js — the main injected script exposed to every origin ' +
        'at a stable path.',
      weight: 1,
      run: () => probeFetch(ID, 'injection/bundle.js'),
    },
    {
      id: 'war-detect-jwplayer-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch detection/detectors/detectJWPlayer.js — a vendor-specific player detector ' +
        'script, distinctive to Substital.',
      weight: 0.5,
      run: () => probeFetch(ID, 'detection/detectors/detectJWPlayer.js'),
    },
    {
      id: 'war-injection-styles-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch injection/styles.css — the subtitle stylesheet, a third path independent ' +
        'of the bundle and detector scripts.',
      weight: 0.5,
      run: () => probeFetch(ID, 'injection/styles.css'),
    },
  ],
};
